import { UserScopes } from '@shared/utils/enums';

import { AppRouteData } from '../interfaces';

export const ROUTES_REQUIRED_SCOPES: Partial<Record<UserScopes, UserScopes[]>> = {
  [UserScopes.CentralHubView]: [
    UserScopes.CentralHubCompaniesView,
    UserScopes.CentralHubStaffManagementView,
    UserScopes.CentralHubRolesPermissionsView,
    UserScopes.CentralHubOperatorsView,
  ],
  [UserScopes.CentralHubOperatorsView]: [
    UserScopes.CentralHubOperatorGeneralInfoView,
    UserScopes.CentralHubLanguageCurrencyView,
    UserScopes.CentralHubOperatorLegalDocumentsView,
    UserScopes.CentralHubOperatorWorkspaceOwnersView,
    UserScopes.CentralHubOperatorsView,
  ],
  [UserScopes.CentralHubOperatorGeneralInfoView]: [UserScopes.CentralHubOperatorGeneralInfoView],
  [UserScopes.CentralHubLanguageCurrencyView]: [UserScopes.CentralHubLanguageCurrencyView],
  [UserScopes.CentralHubOperatorLegalDocumentsView]: [UserScopes.CentralHubOperatorLegalDocumentsView],
  [UserScopes.CentralHubOperatorLicensesView]: [UserScopes.CentralHubOperatorLicensesView],
  [UserScopes.CentralHubOperatorWorkspaceOwnersView]: [UserScopes.CentralHubOperatorWorkspaceOwnersView],
  [UserScopes.CentralHubOperatorWorkspaceOwnersManage]: [UserScopes.CentralHubOperatorWorkspaceOwnersManage],
  [UserScopes.CentralHubUserManagementView]: [UserScopes.CentralHubStaffManagementView, UserScopes.CentralHubRolesPermissionsView],
  [UserScopes.CentralHubStaffManagementView]: [UserScopes.CentralHubStaffManagementView],
  [UserScopes.CentralHubRolesPermissionsView]: [UserScopes.CentralHubRolesPermissionsView],
  [UserScopes.CentralHubCompaniesView]: [UserScopes.CentralHubCompaniesView, UserScopes.CentralHubCompanyGeneralView],
  [UserScopes.CentralHubCompanyGeneralView]: [UserScopes.CentralHubCompanyGeneralView],
  [UserScopes.CentralHubCompanyGeneralManage]: [UserScopes.CentralHubCompanyGeneralManage],
  [UserScopes.PlatformView]: [
    UserScopes.PlatformView,
    UserScopes.PlatformOperatorsView,
    UserScopes.PlatformOperatorGeneralSettingsView,
    UserScopes.PlatformAuthenticationProfileSettingsView,
    UserScopes.PlatformAuthenticationSecurityView,
    UserScopes.PlatformAuthenticationKYCView,
    UserScopes.PlatformOperatorWebsiteView,
    UserScopes.PlatformOperatorUserSettingsView,
    UserScopes.PlatformThirdPartyView,
    UserScopes.PlatformOperatorThirdPartySportsView,
    UserScopes.PlatformOperatorThirdPartyPaymentsView,
    UserScopes.PlatformOperatorThirdPartyCasinoView,
    UserScopes.PlatformOperatorThirdPartyLiveSupportView,
    UserScopes.PlatformOperatorThirdPartyEmailView,
    UserScopes.PlatformOperatorThirdPartyOthersView,
    UserScopes.PlatformOperatorThirdPartySmsView,
    UserScopes.PlatformOperatorThirdPartyToolsView,
    UserScopes.PlatformOperatorThirdPartyKycView,
    UserScopes.PlatformAuthenticationProfileSettingsView,
    UserScopes.PlatformAuthenticationSecurityView,
    UserScopes.PlatformAuthenticationKYCView,
    UserScopes.PlatformAuthenticationRegistrationFormView,
  ],
  [UserScopes.PlatformOperatorsView]: [
    UserScopes.PlatformOperatorsView,
    UserScopes.PlatformOperatorGeneralSettingsView,
    UserScopes.PlatformAuthenticationProfileSettingsView,
    UserScopes.PlatformAuthenticationSecurityView,
    UserScopes.PlatformAuthenticationKYCView,
    UserScopes.PlatformAuthenticationRegistrationFormView,
    UserScopes.PlatformOperatorCountriesView,
    UserScopes.PlatformOperatorWebsiteView,
    UserScopes.PlatformOperatorUserSettingsView,
    UserScopes.PlatformThirdPartyView,
    UserScopes.PlatformOperatorThirdPartySportsView,
    UserScopes.PlatformOperatorThirdPartyPaymentsView,
    UserScopes.PlatformOperatorThirdPartyCasinoView,
    UserScopes.PlatformOperatorThirdPartyLiveSupportView,
    UserScopes.PlatformOperatorThirdPartyEmailView,
    UserScopes.PlatformOperatorThirdPartyOthersView,
    UserScopes.PlatformOperatorThirdPartySmsView,
    UserScopes.PlatformOperatorThirdPartyToolsView,
    UserScopes.PlatformOperatorThirdPartyKycView,
  ],
  [UserScopes.PlatformOperatorGeneralSettingsView]: [
    UserScopes.PlatformOperatorGeneralSettingsView,
    UserScopes.PlatformOperatorWebsiteView,
    UserScopes.PlatformOperatorUserSettingsView,
    UserScopes.PlatformOperatorCountriesView,
  ],
  [UserScopes.PlatformOperatorUserSettingsView]: [UserScopes.PlatformOperatorUserSettingsView],
  [UserScopes.PlatformOperatorWebsiteView]: [UserScopes.PlatformOperatorWebsiteView],
  [UserScopes.PlatformOperatorCountriesView]: [UserScopes.PlatformOperatorCountriesView],
  [UserScopes.PlatformAuthenticationView]: [
    UserScopes.PlatformAuthenticationView,
    UserScopes.PlatformAuthenticationSecurityView,
    UserScopes.PlatformAuthenticationKYCView,
    UserScopes.PlatformAuthenticationProfileSettingsView,
    UserScopes.PlatformAuthenticationRegistrationFormView,
  ],
  [UserScopes.PlatformAuthenticationRegistrationFormView]: [UserScopes.PlatformAuthenticationRegistrationFormView],
  [UserScopes.PlatformAuthenticationKYCView]: [UserScopes.PlatformAuthenticationKYCView],
  [UserScopes.PlatformAuthenticationSecurityView]: [UserScopes.PlatformAuthenticationSecurityView],
  [UserScopes.PlatformAuthenticationProfileSettingsView]: [UserScopes.PlatformAuthenticationProfileSettingsView],
  [UserScopes.PlatformThirdPartyView]: [
    UserScopes.PlatformThirdPartyView,
    UserScopes.PlatformOperatorThirdPartySmsView,
    UserScopes.PlatformOperatorThirdPartyToolsView,
    UserScopes.PlatformOperatorThirdPartyKycView,
    UserScopes.PlatformOperatorThirdPartyOthersView,
    UserScopes.PlatformOperatorThirdPartyEmailView,
    UserScopes.PlatformOperatorThirdPartyLiveSupportView,
    UserScopes.PlatformOperatorThirdPartyCasinoView,
    UserScopes.PlatformOperatorThirdPartyPaymentsView,
    UserScopes.PlatformOperatorThirdPartySportsView,
  ],
  [UserScopes.PlatformOperatorThirdPartySmsView]: [UserScopes.PlatformOperatorThirdPartySmsView],
  [UserScopes.PlatformOperatorThirdPartyToolsView]: [UserScopes.PlatformOperatorThirdPartyToolsView],
  [UserScopes.PlatformOperatorThirdPartyKycView]: [UserScopes.PlatformOperatorThirdPartyKycView],
  [UserScopes.PlatformOperatorThirdPartyEmailView]: [UserScopes.PlatformOperatorThirdPartyEmailView],
  [UserScopes.PlatformOperatorThirdPartyLiveSupportView]: [UserScopes.PlatformOperatorThirdPartyLiveSupportView],
  [UserScopes.PlatformOperatorThirdPartyCasinoView]: [UserScopes.PlatformOperatorThirdPartyCasinoView],
  [UserScopes.PlatformOperatorThirdPartyPaymentsView]: [UserScopes.PlatformOperatorThirdPartyPaymentsView],
  [UserScopes.PlatformOperatorThirdPartySportsView]: [UserScopes.PlatformOperatorThirdPartySportsView],
  [UserScopes.PlatformOperatorThirdPartyOthersView]: [UserScopes.PlatformOperatorThirdPartyOthersView],
  [UserScopes.ChangelogView]: [UserScopes.ChangelogView],
  [UserScopes.CentralHubOperatorGeneralInfoManage]: [UserScopes.CentralHubOperatorGeneralInfoManage],
  [UserScopes.CentralHubOperatorLegalDocumentsManage]: [UserScopes.CentralHubOperatorLegalDocumentsManage],
  [UserScopes.CentralHubCompaniesManage]: [
    UserScopes.CentralHubCompaniesManage,
    UserScopes.CentralHubCompanyGeneralManage,
    UserScopes.CentralHubCompanyManage,
  ],
  [UserScopes.PlatformOperatorUserSettingsManage]: [UserScopes.PlatformOperatorUserSettingsManage],
  [UserScopes.PlatformOperatorWebsiteManage]: [UserScopes.PlatformOperatorWebsiteManage],
  [UserScopes.CentralHubOperatorLicensesManage]: [UserScopes.CentralHubOperatorLicensesManage],
  [UserScopes.CentralHubLanguageCurrencyManage]: [UserScopes.CentralHubLanguageCurrencyManage],
  [UserScopes.CentralHubOperatorsManage]: [
    UserScopes.CentralHubOperatorsManage,
    UserScopes.CentralHubOperatorManage,
    UserScopes.CentralHubOperatorLegalDocumentsManage,
    UserScopes.CentralHubOperatorLicensesManage,
    UserScopes.CentralHubOperatorGeneralInfoManage,
    UserScopes.CentralHubOperatorWorkspaceOwnersManage,
  ],
  [UserScopes.PlatformAuthenticationKYCManage]: [UserScopes.PlatformAuthenticationKYCManage],
  [UserScopes.PlatformAuthenticationProfileSettingsManage]: [UserScopes.PlatformAuthenticationProfileSettingsManage],
  [UserScopes.PlatformAuthenticationRegistrationFormManage]: [UserScopes.PlatformAuthenticationRegistrationFormManage],
  [UserScopes.PlatformAuthenticationSecurityManage]: [UserScopes.PlatformAuthenticationSecurityManage],
  [UserScopes.CentralHubStaffManagementManage]: [UserScopes.CentralHubStaffManagementManage],
  [UserScopes.PlatformOperatorThirdPartySportsManage]: [UserScopes.PlatformOperatorThirdPartySportsManage],
  [UserScopes.PlatformOperatorThirdPartyPaymentsManage]: [UserScopes.PlatformOperatorThirdPartyPaymentsManage],
  [UserScopes.PlatformOperatorThirdPartyCasinoManage]: [UserScopes.PlatformOperatorThirdPartyCasinoManage],
  [UserScopes.PlatformOperatorThirdPartyToolsManage]: [UserScopes.PlatformOperatorThirdPartyToolsManage],
  [UserScopes.PlatformOperatorThirdPartyKycManage]: [UserScopes.PlatformOperatorThirdPartyKycManage],
  [UserScopes.PlatformOperatorThirdPartyOthersManage]: [UserScopes.PlatformOperatorThirdPartyOthersManage],
  [UserScopes.PlatformOperatorThirdPartyLiveSupportManage]: [UserScopes.PlatformOperatorThirdPartyLiveSupportManage],
  [UserScopes.PlatformOperatorThirdPartySmsManage]: [UserScopes.PlatformOperatorThirdPartySmsManage],
  [UserScopes.PlatformOperatorThirdPartyEmailManage]: [UserScopes.PlatformOperatorThirdPartyEmailManage],
  [UserScopes.PlatformOperatorCountriesManage]: [UserScopes.PlatformOperatorCountriesManage],
  [UserScopes.CentralHubRolesPermissionManage]: [UserScopes.CentralHubRolesPermissionManage],
  [UserScopes.CentralHubUserInvite]: [UserScopes.CentralHubUserInvite],
  [UserScopes.QuickToolView]: [UserScopes.QuickToolView],
  [UserScopes.QuickToolManage]: [UserScopes.QuickToolManage],
  [UserScopes.AggregatorView]: [UserScopes.AggregatorView, UserScopes.AggregatorOperatorsView],
  [UserScopes.AggregatorOperatorsView]: [UserScopes.AggregatorOperatorsView],
  [UserScopes.AggregatorManage]: [UserScopes.AggregatorManage, UserScopes.AggregatorOperatorsManage],
  [UserScopes.AggregatorOperatorsManage]: [UserScopes.AggregatorOperatorsManage],
  [UserScopes.RmtView]: [UserScopes.RmtView],
  [UserScopes.RmtManage]: [UserScopes.RmtManage],
  [UserScopes.CrmView]: [UserScopes.CrmView],
  [UserScopes.CrmManage]: [UserScopes.CrmManage],
};

export const ROUTE_SCOPES_DATA_MAP: Partial<Record<UserScopes, AppRouteData>> = {
  [UserScopes.CentralHubView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubView] },
  [UserScopes.CentralHubCompaniesView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubCompaniesView] },
  [UserScopes.CentralHubCompanyGeneralView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubCompanyGeneralView] },
  [UserScopes.CentralHubOperatorsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubOperatorsView] },
  [UserScopes.CentralHubOperatorGeneralInfoView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubOperatorGeneralInfoView] },
  [UserScopes.CentralHubLanguageCurrencyView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubLanguageCurrencyView] },
  [UserScopes.CentralHubOperatorLegalDocumentsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubOperatorLegalDocumentsView] },
  [UserScopes.CentralHubOperatorWorkspaceOwnersView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubOperatorWorkspaceOwnersView] },
  [UserScopes.CentralHubUserManagementView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubUserManagementView] },
  [UserScopes.CentralHubStaffManagementView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubStaffManagementView] },
  [UserScopes.CentralHubRolesPermissionsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CentralHubRolesPermissionsView] },
  [UserScopes.PlatformView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformView] },
  [UserScopes.PlatformOperatorsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformOperatorsView] },
  [UserScopes.PlatformOperatorGeneralSettingsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformOperatorGeneralSettingsView] },
  [UserScopes.PlatformOperatorCountriesView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformOperatorCountriesView] },
  [UserScopes.PlatformOperatorUserSettingsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformOperatorUserSettingsView] },
  [UserScopes.PlatformOperatorWebsiteView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformOperatorWebsiteView] },
  [UserScopes.PlatformThirdPartyView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformThirdPartyView] },
  [UserScopes.PlatformAuthenticationView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformAuthenticationView] },
  [UserScopes.PlatformAuthenticationRegistrationFormView]: {
    scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformAuthenticationRegistrationFormView],
  },
  [UserScopes.PlatformAuthenticationKYCView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformAuthenticationKYCView] },
  [UserScopes.PlatformAuthenticationSecurityView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformAuthenticationSecurityView] },
  [UserScopes.PlatformAuthenticationProfileSettingsView]: {
    scopes: ROUTES_REQUIRED_SCOPES[UserScopes.PlatformAuthenticationProfileSettingsView],
  },
  [UserScopes.QuickToolView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.QuickToolView] },
  [UserScopes.AggregatorView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.AggregatorView] },
  [UserScopes.AggregatorOperatorsView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.AggregatorOperatorsView] },
  [UserScopes.CrmView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.CrmView] },
  [UserScopes.RmtView]: { scopes: ROUTES_REQUIRED_SCOPES[UserScopes.RmtView] },
};
